import ReactDOM from 'react-dom';
import sharedStyles from './Modals.module.css';
import styles from './SelectionModal.module.css';
import ThresholdBar from './ThresholdBar';

function SelectionModal({ onClose, showBackButton = false }) {
    const modal = (
        <div className={sharedStyles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className={sharedStyles.shell} role="dialog" aria-modal="true" aria-labelledby="selection-title">
                {/* Header */}
                <div className={sharedStyles.head}>
                    <div className={sharedStyles.headInner}>
                        {showBackButton && (
                            <button className={sharedStyles.backBtn} onClick={onClose} aria-label="Go back">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Back
                            </button>
                        )}
                        <div className={sharedStyles.headLeft}>
                            <span className={sharedStyles.eyebrow}>Review &amp; Earn</span>
                            <span className={sharedStyles.titleTxt} id="selection-title">How selection works</span>
                        </div>
                    </div>
                    <button className={sharedStyles.closeBtn} onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>

                {/* Scrollable content */}
                <div className={sharedStyles.scrollableContent}>
                    {/* Monthly review opportunities */}
                    <div className={sharedStyles.contentSection}>
                        <div className={sharedStyles.sectionHeader}>
                            <div className={`${sharedStyles.sectionIcon} ${sharedStyles.iconAmber}`}>
                                <svg viewBox="0 0 13 13" fill="none">
                                    <circle cx="6.5" cy="6.5" r="5" stroke="#f0a04b" strokeWidth="1.2" />
                                    <path d="M6.5 4v3l1.5 1.5" stroke="#f0a04b" strokeWidth="1.2" strokeLinecap="round" />
                                </svg>
                            </div>
                            <span className={sharedStyles.sectionTitle}>Monthly review opportunities</span>
                        </div>
                        <div className={sharedStyles.sectionBody}>
                            <div className={sharedStyles.userClassRow}>
                                <span className={sharedStyles.userClassPip} style={{ background: '#f0a04b' }} />
                                <span className={sharedStyles.userClassName}>Amplifier</span>
                                <span className={sharedStyles.userClassDetail}>Up to 10 reviews per month to qualify</span>
                                <span className={`${sharedStyles.userClassBadge} ${sharedStyles.badgeAmber}`}>10 / month</span>
                            </div>
                            <div className={sharedStyles.userClassRow}>
                                <span className={sharedStyles.userClassPip} style={{ background: '#c98af0' }} />
                                <span className={sharedStyles.userClassName}>Innovator</span>
                                <span className={sharedStyles.userClassDetail}>Up to 30 priority reviews per month</span>
                                <span className={`${sharedStyles.userClassBadge} ${sharedStyles.badgePurple}`}>30 / month</span>
                            </div>
                            <div className={sharedStyles.userClassRow}>
                                <span className={sharedStyles.userClassPip} style={{ background: '#60c87a' }} />
                                <span className={sharedStyles.userClassName}>Validator</span>
                                <span className={sharedStyles.userClassDetail}>Permanent access once selected — no cap</span>
                                <span className={`${sharedStyles.userClassBadge} ${sharedStyles.badgeGreen}`}>Unlimited</span>
                            </div>
                        </div>
                    </div>

                    {/* Earning points */}
                    <div className={sharedStyles.contentSection}>
                        <div className={sharedStyles.sectionHeader}>
                            <div className={`${sharedStyles.sectionIcon} ${sharedStyles.iconBlue}`}>
                                <svg viewBox="0 0 13 13" fill="none">
                                    <path d="M6.5 1.5l1.2 2.4 2.6.4-1.9 1.8.45 2.6L6.5 7.5 4.15 8.7l.45-2.6L2.7 4.3l2.6-.4L6.5 1.5z" stroke="#7ab3f0" strokeWidth="1.1" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span className={sharedStyles.sectionTitle}>Earning points</span>
                        </div>
                        <div className={sharedStyles.sectionBody}>
                            <div className={sharedStyles.pointsRow}>
                                <span className={sharedStyles.pointsNumber}>100</span>
                                <span className={sharedStyles.pointsLabel}>
                                    points per video, <strong>only when your score is within ±15% of the final consensus score and your pass/fail checks match.</strong> Scores outside this range earn no points.
                                </span>
                            </div>
                            <ThresholdBar />
                        </div>
                    </div>

                    {/* Validator spots & monthly cycle */}
                    <div className={sharedStyles.contentSection}>
                        <div className={sharedStyles.sectionHeader}>
                            <div className={`${sharedStyles.sectionIcon} ${sharedStyles.iconRed}`}>
                                <svg viewBox="0 0 13 13" fill="none">
                                    <path d="M10.5 6.5A4 4 0 1 1 6.5 2.5" stroke="#e05555" strokeWidth="1.2" strokeLinecap="round" />
                                    <path d="M6.5 2.5l2-2v4l-2-2z" fill="#e05555" />
                                </svg>
                            </div>
                            <span className={sharedStyles.sectionTitle}>Validator spots &amp; monthly cycle</span>
                        </div>
                        <div className={sharedStyles.sectionBody}>
                            <div className={styles.statChips}>
                                <div className={styles.statChip}>
                                    <div className={styles.statValue} style={{ color: '#7ab3f0' }}>100</div>
                                    <div className={styles.statLabel}>Total validator spots</div>
                                </div>
                                <div className={styles.statChip}>
                                    <div className={styles.statValue} style={{ color: '#e05555' }}>25</div>
                                    <div className={styles.statLabel}>Removed each month</div>
                                </div>
                                <div className={styles.statChip}>
                                    <div className={styles.statValue} style={{ color: '#60c87a' }}>25</div>
                                    <div className={styles.statLabel}>New spots opened</div>
                                </div>
                            </div>
                            <div className={styles.cycleSteps}>
                                <div className={styles.sectionStep}>
                                    <div className={styles.sectionSpine}>
                                        <div className={`${styles.sectionNumber} ${styles.sectionNumBlue}`}>1</div>
                                        <div className={styles.sectionLine} />
                                    </div>
                                    <div className={styles.sectionStepBody}>
                                        <div className={styles.sectionStepTitle}>Launch grant</div>
                                        <div className={styles.sectionDescription}>
                                            When the program opens, the <strong>top 100 ranked members</strong> by score are granted Validator status.
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.sectionStep}>
                                    <div className={styles.sectionSpine}>
                                        <div className={`${styles.sectionNumber} ${styles.sectionNumRed}`}>2</div>
                                        <div className={styles.sectionLine} />
                                    </div>
                                    <div className={styles.sectionStepBody}>
                                        <div className={styles.sectionStepTitle}>End-of-month review</div>
                                        <div className={styles.sectionDescription}>
                                            The <strong>bottom 25% of Validators</strong> (by QA points earned that month) lose their status, freeing <strong>25 spots.</strong>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.sectionStep}>
                                    <div className={styles.sectionSpine}>
                                        <div className={`${styles.sectionNumber} ${styles.sectionNumGreen}`}>3</div>
                                    </div>
                                    <div className={styles.sectionStepBody}>
                                        <div className={styles.sectionStepTitle}>New grants</div>
                                        <div className={styles.sectionDescription}>
                                            The <strong>top 25 non-Validator members</strong> by score ranking are promoted to fill the open spots.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={sharedStyles.infoNote}>
                                <span className={sharedStyles.infoNoteIcon}>ⓘ</span>
                                <span className={sharedStyles.infoNoteText}>
                                    <strong>Grace period:</strong> Newly granted Validators are exempt from elimination during their first full month. Eligibility starts in month two.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modal, document.body);
}

export default SelectionModal;